export const logout = () => {
    localStorage.removeItem('t');
    localStorage.removeItem('rt');
    window.location.href = `${window.location.origin}/login/`;
};
